import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("ss_cookie_consent")) setShow(true);
  }, []);
  const accept = () => { localStorage.setItem("ss_cookie_consent", "necessary"); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 1.5 }}
          className="fixed bottom-24 left-5 right-5 sm:bottom-5 sm:left-auto sm:right-28 sm:max-w-md z-[70] card-glass p-6"
          data-testid="cookie-banner"
        >
          <p className="eyebrow !text-[0.6rem] mb-3">Datenschutz-Hinweis</p>
          <p className="text-sm text-[var(--muted)] leading-relaxed">
            Diese Website verwendet ausschließlich technisch notwendige Speichertechnologien. Es findet kein Tracking und keine Weitergabe an Dritte zu Werbezwecken statt. Details in der{" "}
            <Link to="/cookies" className="text-[var(--gold)] underline underline-offset-4">Cookie-Richtlinie</Link>.
          </p>
          <div className="mt-5 flex gap-3">
            <button onClick={accept} className="btn-gold !py-2.5 !px-5 text-xs" data-testid="cookie-accept-button">Verstanden</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
